/* eslint-disable max-len */

"use strict";

const { isNullOrEmpty, getFullUrl } = require("@nuskin/ns-common-lib");

const ProductUtils = {
  /**
   * Returns string needed for getting product data from PMD
   * Example full url where this is used: "https://test.nuskin.com/content/products/01/16/08/01160862/en.service.US.json"
   * @param {string} sku - ex. "01160862"
   * @returns tokenized sku - ex. "01/16/08/01160862"
   */
  getTokenizedSku: function(sku) {
    let { part1, part2, part3 } = this.getTokenizedSkuParts(sku);
    return `${part1}/${part2}/${part3}/${sku}`;
  },

  /**
   * Returns string parts needed for getting product data from PMD
   * @param {string} sku - ex. "01160862"
   * @returns {{ part1, part2, part3 }} tokenized sku parts - ex. { "part1": "01", "part2": "16", "part3": "08" }
   */
  getTokenizedSkuParts: function(sku) {
    let part1 = sku.substring(0, 2); // "01"
    let part2 = sku.substring(2, 4); // "11"
    let part3 = sku.substring(4, 6); // "11"
    return {
      part1,
      part2,
      part3
    };
  },

  /**
   * Applies a Base URL by prepending it to an existing URL when applicable
   * @param {string} url - ex. "content/..." or "http://test.nuskin.com/content/..."
   * @param {string} baseUrl - ex. "http://test.nuskin.com"
   * @returns {string} full url
   */
  applyBaseUrl: function(url, baseUrl) {
    const fullUrl = getFullUrl(baseUrl, url);
    return fullUrl.replace("http://", "https://");
  },

  mergeOrderTypes: function(previousOrderTypes, newOrderTypes) {
    // untrust previous order types, override them to false
    const previousOrderTypesMapping = this.getOrderTypesMapping(previousOrderTypes, true);

    // trust new order types
    const newOrderTypesMapping = this.getOrderTypesMapping(newOrderTypes);

    return {
      ...previousOrderTypesMapping,
      ...newOrderTypesMapping
    };
  },
  
  /**
   * Gets the order types as a dictionary/mapping of order type to value
   * @param {string[] | object[]} orderTypes - ex. ["adr", "order"] or { adr: false, order: true }
   * @param {boolean} override - used to force the value of each orderType to false
   * @returns {object} order types dictionary/mapping
   */
  getOrderTypesMapping: function(orderTypes, override = false) {
    if (isNullOrEmpty(orderTypes)) {
      return {};
    }
    const orderTypesMapping = {};
    if (Array.isArray(orderTypes)) {
      for (const orderType of orderTypes) {
        orderTypesMapping[orderType.toLowerCase()] = !override;
      }
    } else {
      for (const orderType in orderTypes) {
        orderTypesMapping[orderType.toLowerCase()] = !override && !!orderTypes[orderType];
      }
    }
    return orderTypesMapping;
  }
};

module.exports = ProductUtils;
